import { useState } from "react";
import { DataTable } from "../components/DataTable";
import { useAuth } from "../context/AuthContext";
import { initialOrders } from "../data/orders";
import type { Order } from "../data/types";

export function OrdersPage() {
  const { user } = useAuth();
  const [orders, setOrders] = useState<Order[]>(initialOrders);
  const [customer, setCustomer] = useState("");
  const [total, setTotal] = useState("");
  const [status, setStatus] = useState("Processing");

  const canManage = user?.role === "admin";

  function addOrder() {
    if (!customer || !total || !canManage) return;
    setOrders((prev) => [
      {
        id: `#NSJ${Math.floor(1000 + Math.random() * 9000)}`,
        customer,
        total: Number(total),
        status,
      },
      ...prev,
    ]);
    setCustomer("");
    setTotal("");
    setStatus("Processing");
  }

  function deleteOrder(id: string) {
    if (!canManage) return;
    setOrders((prev) => prev.filter((item) => item.id !== id));
  }

  return (
    <div className="d-grid gap-3">
      {canManage ? (
        <div className="card border-0 shadow-sm">
          <div className="card-body">
            <div className="row g-2">
              <div className="col-md-4">
                <input
                  className="form-control"
                  placeholder="Customer"
                  value={customer}
                  onChange={(e) => setCustomer(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <input
                  className="form-control"
                  type="number"
                  placeholder="Total"
                  value={total}
                  onChange={(e) => setTotal(e.target.value)}
                />
              </div>
              <div className="col-md-3">
                <select
                  className="form-select"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option>Processing</option>
                  <option>Shipped</option>
                  <option>Delivered</option>
                  <option>Cancelled</option>
                </select>
              </div>
              <div className="col-md-2">
                <button type="button" className="btn btn-primary w-100" onClick={addOrder}>
                  Add Order
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}

      <DataTable
        title="Orders"
        rows={orders}
        columns={[
          { key: "id", label: "Order ID", sortable: true },
          { key: "customer", label: "Customer", sortable: true },
          { key: "total", label: "Total", sortable: true, render: (row) => `Rs ${row.total.toLocaleString()}` },
          {
            key: "status",
            label: "Status",
            render: (row) => {
              const statusClass =
                row.status === "Delivered"
                  ? "text-bg-success"
                  : row.status === "Cancelled"
                    ? "text-bg-danger"
                    : "text-bg-info";
              return <span className={`badge ${statusClass}`}>{String(row.status)}</span>;
            },
          },
          canManage
            ? {
                key: "actions",
                label: "Actions",
                className: "text-end",
                render: (row) => (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => deleteOrder(row.id)}
                  >
                    Delete
                  </button>
                ),
              }
            : { key: "placeholder", label: "", render: () => null },
        ]}
        rowKey={(row) => row.id}
        searchPlaceholder="Search orders..." exportFileName="orders"
        onDeleteRow={(id) => deleteOrder(id)}
        deleteItemLabel="Order"
      />
    </div>
  );
}
